const promoBanner = {
    init: function() {
        promoBanner.setPromoTimer();
    },
    setPromoTimer: function() {
        if (!_d.promoBanner.endTime) {
            return;
        }

        const countDownDate = new Date(_d.promoBanner.endTime).getTime();
        setTimer();
        const interval = setInterval(setTimer, 1000);

        function setTimer() {
            const now = new Date().getTime();
            const difference = countDownDate - now;

            if (difference < 0) {
                if (interval) {
                    clearInterval(interval);
                }

                const elements = document.getElementsByClassName('promo-campaign');

                while (elements.length > 0) {
                    elements[0].parentNode.removeChild(elements[0]);
                }
            } else {
                const days = Math.floor(difference / (1000 * 60 * 60 * 24));
                const hours = ('0' + Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
                const minutes = ('0' + Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);

                $('#promo-days').html(`${days}<span>d</span>`);
                $('#promo-hours').html(`${hours}<span>h</span>`);
                $('#promo-minutes').html(`${minutes}<span>m</span>`);
            }
        }
    },
    hide: function() {
        $('.promo-campaign').hide();
    }
};
